export const API_URL = "https://backend-stage.liara.run/";
export default API_URL;
